import { BankAccountExportTicketSchema, BankAccountListSchema, BankAccountSchema,
  SaveBankAccountResponseSchema, type BankAccount, type BankAccountList,
  type SaveBankAccountResponse } from '@youkuai/contracts';

import { apiDownload, apiRequest } from './project-api.ts';

export async function getOwnBankAccount(token: string): Promise<BankAccount> {
  return BankAccountSchema.parse(await apiRequest('/me/payee/bank-account', token));
}

export async function listBankAccounts(token: string, input: { search?: string; afterCode?: string;
  limit?: number } = {}): Promise<BankAccountList> {
  const query = new URLSearchParams({ limit: String(input.limit ?? 50) });
  if (input.search?.trim()) query.set('search', input.search.trim());
  if (input.afterCode) query.set('afterCode', input.afterCode);
  return BankAccountListSchema.parse(await apiRequest(`/payees/bank-accounts?${query}`, token));
}

export async function getBankAccount(token: string, payeeId: string): Promise<BankAccount> {
  return BankAccountSchema.parse(await apiRequest(
    `/payees/${encodeURIComponent(payeeId)}/bank-account`, token));
}

export async function saveBankAccount(input: { token: string; payeeId: string; expectedVersion: number;
  accountHolder: string; bankName: string; accountNumber: string; bankLocation: string; paymentNote: string; reason: string;
  idempotencyKey: string }): Promise<SaveBankAccountResponse> {
  return SaveBankAccountResponseSchema.parse(await apiRequest(
    `/payees/${encodeURIComponent(input.payeeId)}/bank-account`, input.token, {
      method: 'PUT', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': input.idempotencyKey },
      body: JSON.stringify({ expectedVersion: input.expectedVersion, accountHolder: input.accountHolder.trim(),
        bankName: input.bankName.trim(), accountNumber: input.accountNumber.trim(),
        bankLocation: input.bankLocation.trim() || null, paymentNote: input.paymentNote.trim() || null,
        reason: input.reason.trim() }),
    }));
}

export async function exportBankAccount(input: { token: string; payeeId: string;
  purpose: string }): Promise<{ file: Blob; ticketId: string }> {
  const root = `/payees/${encodeURIComponent(input.payeeId)}/bank-account/exports`;
  const ticket = BankAccountExportTicketSchema.parse(await apiRequest(root, input.token, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ purpose: input.purpose.trim() }),
  }));
  const file = await apiDownload(`${root}/${encodeURIComponent(ticket.ticketId)}`, input.token);
  return { file, ticketId: ticket.ticketId };
}
